<div class="pos-panel">
    <div class="pos-new-entity-header">
        <span class="material-icons success">login</span>
        <span class="soc-panel-h">{{"TRANSFER.INCOMING_TRANSFER_DETAILS" | translate}}</span>
        <span class="soc-pill-lbl soc-neutral-30-pill-outline">{{transfer.statusType}}</span>
    </div>
    <hr class="soc-panel-line"/>
    <div class="pos-actions-wrapper">
        <div class="soc-wrapper-gap-24">
            <div *ngIf="transfer.issuedByUser" class="soc-display-field-wrapper">
                <label class="soc-input-lbl w-100 text-start">{{"TRANSFER.ISSUED_BY" | translate}}</label>
                <div class="soc-display-field"> <span class="soc-display-text">{{transfer.issuedByUser.firstName}} {{transfer.issuedByUser.lastName}}</span></div>
            </div>
            <div class="soc-display-field-wrapper">
                <label class="soc-input-lbl w-100 text-start">{{"TRANSFER.ISSUE_DATE" | translate}}</label>
                <div *ngIf="transfer.issuedOn" class="soc-display-field"> <span class="soc-display-text">{{transfer.issuedOn | date: 'dd MMM YYYY'}}</span></div>
            </div>
            <div *ngIf="transfer.receivedByUser" class="soc-display-field-wrapper">
                <label class="soc-input-lbl w-100 text-start">{{"TRANSFER.RECIEVED_BY" | translate}}</label>
                <div class="soc-display-field"> <span class="soc-display-text">{{transfer.receivedByUser.firstName}} {{transfer.receivedByUser.lastName}}</span>
            </div>
            </div>
            <div *ngIf="transfer.receivedOn" class="soc-display-field-wrapper">
                <label class="soc-input-lbl w-100 text-start">{{"TRANSFER.RECEIPT_DATE" | translate}}</label>
                <div class="soc-display-field"> <span class="soc-display-text">{{transfer.receivedOn | date: 'dd MMM YYYY'}}</span>
            </div>
            </div>
        </div>
        <div class="soc-display-field-wrapper">
            <label class="soc-input-lbl w-100 text-start">{{"TRANSFER.SOURCE_INVENTORY" | translate}}</label>
            <div class="soc-display-field"> <span class="soc-display-text">{{transfer.sourceVenueInventory?.name}}</span></div>     
        </div>
    </div>
    <p-table *ngIf="transfer.lineItems" class="soc-borderless-table soc-checkbox-table soc-editable-table" [value]="transfer.lineItems" [(selection)]="selectedItems" [scrollable]="true" [virtualScroll]="true" scrollHeight="calc(100vh - 462px)">
        <ng-template pTemplate="header">
            <tr>
                <th>
                    <p-tableHeaderCheckbox [disabled]="true"></p-tableHeaderCheckbox>
                </th>
                <th>{{"INVENTORY_ITEM.CODE" | translate}}</th>
                <th>{{"INVENTORY_ITEM.ITEM_NAME" | translate}}</th>
                <th>{{"INVENTORY_ITEM.QUANTITY" | translate}}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-transferItem>
            <tr>
                <td>
                    <p-tableCheckbox [disabled]="true" [value]="transferItem"></p-tableCheckbox>
                </td>
                <td class="secondary-td">{{transferItem.item.code}}</td>
                <td>{{transferItem.item.name}}</td>
                <td>
                      {{transferItem.quantityReceived ? transferItem.quantityReceived : "-"}} {{transferItem.quantityReceived ? (transferItem.item.unitType | unitShortener | lowercase) : ""}}
                </td>
            </tr>
        </ng-template>
    </p-table>
    
    <hr class="soc-panel-line"/>
    <div class="d-flex align-items-center justify-content-between">
        <button class="soc-secondary-grey-btn" (click)="navigateToMain()"><span class="material-icons-round">arrow_back</span>{{"BACK" | translate}}</button>
    </div>
</div>
